import Dot from "@/v2-backoffice-client/components/dot"
import {
  visibilityDotVariant,
  visibilityTypeLabel,
} from "@/v2-backoffice-client/tenant/privacy/tenant.privacy.utils"
import type { PrivacyVisibilityType } from "@/v2-backoffice-client/tenant/privacy/tenant.privacy.types"

export type TenantPrivacyHistoryTransitionProps = {
  fromCode: number
  toCode: number
  visibilityTypes: PrivacyVisibilityType[]
}

// One before → after, with the editor's dots so the colour reads the same as
// in the table. The state that matters is the one the write left behind, so
// "after" is the only part in full colour; "before" and the arrow recede.
function TenantPrivacyHistoryTransition(
  props: TenantPrivacyHistoryTransitionProps,
) {
  const { fromCode, toCode, visibilityTypes } = props

  return (
    <span className="inline-flex items-center gap-1.5 whitespace-nowrap">
      <span className="inline-flex items-center gap-1 text-muted-foreground">
        <Dot variant={visibilityDotVariant(fromCode)} />
        {visibilityTypeLabel(fromCode, visibilityTypes)}
      </span>
      <span className="text-muted-foreground">→</span>
      <span className="inline-flex items-center gap-1">
        <Dot variant={visibilityDotVariant(toCode)} />
        {visibilityTypeLabel(toCode, visibilityTypes)}
      </span>
    </span>
  )
}

export default TenantPrivacyHistoryTransition
